import { MoreDotsIcon } from '@tableau/icons/MoreDotsIcon';
import { DropdownButtonType, HierarchicalDropdownWidget, MenuItemInfo } from '@tableau/widgets';
import React from 'react';

import { Keys } from '~commonInfra/utils/Keys';

import { Messages } from '../../codegen/Localize';
import { NotificationMenuItem } from '../menuProviders/IUserNotificationMenuItemProvider';
import * as notificationStyles from '../styles/notificationStyles';
import { sendUserNotificationItemActionTelemetry, UserNotificationsTelemetryEvents } from '../telemetry/UserNotificationsTelemetry';

export interface NotificationActionsProps {
  notificationId: string;
  notificationType: string;
  actions: Array<NotificationMenuItem>;
  closePanel: () => void;
  userId: string;
  siteLuid: string;
}

export function NotificationActions(props: NotificationActionsProps & React.HTMLAttributes<HTMLButtonElement>) {
  const { actions, closePanel, notificationId, notificationType, siteLuid, userId, ...htmlProps } = props;

  function createMenuItems(): MenuItemInfo[] {
    const menuItems: MenuItemInfo[] = [];
    actions.map((action, index) => menuItems.push({ displayValue: action.title, value: index.toString() }));
    return menuItems;
  }

  function onSelect(value: string) {
    const actionType = actions[Number(value)].title;
    sendUserNotificationItemActionTelemetry(UserNotificationsTelemetryEvents.notificationItemAction, userId, siteLuid, notificationType, actionType);
    actions[Number(value)].onClick();
    if(actions[Number(value)].closePanel){
      closePanel();
    }
  }

  function getIconButtonContent() {
    return <MoreDotsIcon size={18} />;
  }

  function handleKeyDown(e: React.KeyboardEvent<HTMLButtonElement>) {
    if (e.keyCode === Keys.ArrowDown) {
      // using preventDefault to signal we do NOT want the default behavior where pressing Down Arrow key opens the dropdown menu;
      // since this component receives focus when using arrow keys to navigate between grid cells,
      // pressing Down Arrow key should actually move focus to the next row (which is handled in NotificationPanel)
      e.preventDefault();
    }
  }

  return (
    <HierarchicalDropdownWidget
      {...htmlProps}
      aria-label={Messages.userNotificationsActions()}
      title={Messages.userNotificationsActions()}
      closeOnPopupBlur={false}
      testId={`notification-action-${notificationId}`}
      onSelect={onSelect}
      menuItemInfos={createMenuItems()}
      label={undefined}
      stackingRootId={'notification-panel'} // this is added as workaround of tfs1156753
      type={DropdownButtonType.Icon}
      children={getIconButtonContent()}
      className={notificationStyles.actionsButton}
      onKeyDown={handleKeyDown}
      popupAlignment={'right'}
      style={{position: 'absolute'}}
    />);
}
